module.exports = __webpack_public_path__ + "static/image-carrusel-hunting-3-48087e773720dd8673a1e2b837e9945f.png";